export default {
    braceletTicketList: {
        method: 'POST',
        url: '/admin/report/braceletTicketList',
        name: '票券手环绑定列表'
    },
    braceletAndGate: {
        method: 'POST',
        url: '/admin/report/braceletAndGate',
        name: '手环-闸机对应信息'
    },
    braceletConsume: {
        method: 'POST',
        url: '/admin/report/braceletConsume',
        name: '每日手环统计'
    },
    braceletTicketExport: {
        method: 'POST',
        url: '/admin/report/exportExcel/braceletTicket',
        name: '导出票券手环绑定列表Excel'
    },
    braceletAndGateExport: {
        method: 'POST',
        url: '/admin/report/braceletAndGate/export',
        name: '导出手环-闸机报表'
    },
    braceletConsumeExport: {
        method: 'POST',
        url: '/admin/report/braceletConsume/export',
        name: '导出每日手环统计表'
    },
    bindBraceletNum: {
        method: 'POST',
        url: '/admin/report/bindBraceletNum',
        name: '票券手环绑定数量'
    },
    braceletAndGateNum: {
        method: 'POST',
        url: '/admin/report/braceletAndGateNum',
        name: '手环-闸机出入闸机人数'
    },
    ticketVerifyTotal: {
        method: 'GET',
        url: '/manage-system/statis/ticketVerifyTotal/{shopId}/{schemeId}/{startDate}/{endDate}',
        name: '票券核销统计'
    },
    exportExcel: {
        method: 'GET',
        url: '/manage-system/statis/ticketVerifyTotal/exportExcel/{shopId}/{schemeId}/{startDate}/{endDate}',
        name: '票券核销统计报表导出复制'
    },
    storedValueRechargeSearch: {
        method: 'POST',
        url: '/admin/storedValue/storedValueRechargeSearch',
        name: '储值充值列表'
    },
    exportConsumeRecharge: {
        method: 'POST',
        url: '/admin/storedValue/exportConsumeRecharge',
        name: '储值充值列表导出报表'
    },
    storedValueSearch: {
        method: 'POST',
        url: '/admin/storedValue/storedValueSearch',
        name: '储值消费统计列表'
    },
    storedValueSearchSum: {
        method: 'POST',
        url: '/admin/storedValue/storedValueSearchSum',
        name: '储值消费统计列表总计和条数'
    },
    exportStoredValue: {
        method: 'POST',
        url: '/admin/storedValue/exportStoredValue',
        name: '储值消费统计导出报表'
    },
    payRecordSearch: {
        method: 'POST',
        url: '/admin/storedValue/payRecordSearch',
        name: '支付记录'
    },
    payRecordSearchSum: {
        method: 'POST',
        url: '/admin/storedValue/payRecordSearchSum',
        name: '支付记录列表和条数'
    },
    refundRecordSearch: {
        method: 'POST',
        url: '/admin/storedValue/userRefundSearch',
        name: '退款记录'
    },
    refundRecordSearchSum: {
        method: 'POST',
        url: '/admin/storedValue/userRefundSearchSum',
        name: '退款记录列表和条数'
    },
    exportPayRecord: {
        method: 'POST',
        url: '/admin/storedValue/exportPayRecord',
        name: '储值支付记录导出'
    },
    exportRefundRecord: {
        method: 'POST',
        url: '/admin/storedValue/exportRefund',
        name: '储值退款记录导出'
    },
    storedValueRechargeSum: {
        method: 'POST',
        url: '/admin/storedValue/storedValueRechargeSum',
        name: '储值充值列表总计和条数'
    },
    queryTicketByShopId: {
        method: 'GET',
        url: '/manage-system/statis/queryTicketByShopId/{shopId}',
        name: '根据门店查询对应的票券'
    },
    saveScheme: {
        method: 'POST',
        url: '/manage-system/statis/saveScheme',
        name: '新增方案'
    },
    editScheme: {
        method: 'PUT',
        url: '/manage-system/statis/editScheme',
        name: '编辑方案'
    },
    delScheme: {
        method: 'DELETE',
        url: '/manage-system/statis/deleteScheme/{schemeId}',
        name: '删除方案'
    },
    queryAllSchemes: {
        method: 'GET',
        url: '/manage-system/statis/queryAllSchemes/{shopId}',
        name: '查询方案'
    },
    schemeInfo: {
        method: 'GET',
        url: '/manage-system/statis/schemeInfo/{schemeId}',
        name: '查询方案的详情信息'
    },
    plusGiveTicket: {
        method: 'POST',
        url: '/admin/plusGiveTicket/list',
        name: '加赠票管理列表'
    },
    wristZnList: {
        method: 'POST',
        url: '/posadmin/ticket/znlist',
        name: '智能腕卡报表 绑定'
    },
    wristZnunlist: {
        method: 'POST',
        url: '/posadmin/ticket/znunlist',
        name: '智能腕卡报表 解绑'
    },
    ticketStatics: {
        method: 'POST',
        url: '/posadmin/ticket/statics',
        name: '时间段内绑定 统计'
    },
    inoutStatics: {
        method: 'POST',
        url: '/posadmin/inout/statics',
        name: '时间段内进出场 统计'
    },
    wristZnExport: {
        method: 'POST',
        url: '/posadmin/ticket/export',
        name: '智能腕卡报表导出'
    },
    wristInoutList: {
        method: 'POST',
        url: '/posadmin/inout/list',
        name: '腕卡进出场列表'
    },
    wristInoutUnList: {
        method: 'POST',
        url: '/posadmin/inout/unlist',
        name: '腕卡未进场列表'
    },
    wristInoutExport: {
        method: 'POST',
        url: '/posadmin/inout/export',
        name: '腕卡进出场列表导出'
    },
    inoutstcsList: {
        method: 'POST',
        url: '/posadmin/inoutstcs/list',
        name: '数据统计列表'
    },
    inoutstcsExport: {
        method: 'POST',
        url: '/posadmin/inoutstcs/export',
        name: '数据统计列表导出'
    },
    inoutstcsCount: {
        method: 'GET',
        url: '/posadmin/inoutstcs/cur/{shopId}',
        name: '当前场内人数'
    },
    settlement: {
        method: 'POST',
        url: '/external-api/ticket_balance_settlement/query',
        name: '当前场内人数'
    },
    // 结算接口
    ticketSettleDetail: {
        method: 'POST',
        url: '/external-api/ticket_verify/queryBalanceDetail',
        name: '票券余额明细查询'
    },
    queryBalanceSettlement: {
        method: 'POST',
        url: '/external-api/ticket_verify/queryBalanceSettlement',
        name: '票券余额结算查询'
    },
    verifyAmountSettlement: {
        method: 'POST',
        url: '/external-api/ticket_verify/verifyAmountSettlement',
        name: '核销金额结算查询'
    },
    ticketVerifyDetailStatistics: {
        method: 'POST',
        url: '/external-api/ticket_verify/ticketVerifyDetailStatistics',
        name: '票券核销详情统计'
    },
    getNormalTitle: {
        method: 'POST',
        url: '/external-api/ticket_verify/title',
        name: '表头2'
    },
    getOtherTitle: {
        method: 'POST',
        url: '/external-api/ticket_verify/corssVerifyTitle',
        name: '其他门店表头'
    },
    crossVerify: {
        method: 'POST',
        url: '/external-api/ticket_verify/crossVerify',
        name: '其他门店跨店核销'
    },
    verifyOtherShop: {
        method: 'POST',
        url: '/external-api/ticket_verify/verifyOtherShop',
        name: '核销其他门店查询'
    },
    VerifyDetail: {
        method: 'POST',
        url: '/external-api/ticket_verify/crossVerifyDetail',
        name: '核销明细'
    },
    crossVerifyDetailExcel: {
        method: 'POST',
        url: '/external-api/ticket_verify/crossVerifyDetailExcel',
        name: '获取其他门店跨店核销明细Excel文件'
    },
    getExtraExport: {
        url: "/external-api/ticket_verify/crossVerifyExcel",
        method: "POST",
        name: "导出其他门店跨店核销Excel文件",
    },
    exportSettleDetail: {
        method: 'POST',
        url: '/external-api/ticket_verify/exportBalanceDetail',
        name: '导出余额结算详情Excel表格文件'
    },
    exportSomeDetail: {
        method: 'POST',
        url: '/external-api/ticket_verify/exportSomeDetail',
        name: '核销票券详情统计额外信息'
    },
    getTicketExport: {
        url: "/external-api/ticket_verify/verifyAmountSettlementExcel",
        method: "POST",
        name: "导出核销金额结算Excel文件"
    },
    exportVerifyOtherShopExcel: {
        url: "/external-api/ticket_verify/exportVerifyOtherShopExcel",
        method: "POST",
        name: "导出核销其他门店Excel文件"
    },

    exprScheme: {
        url: "/external-api/ticket_verify/expr_scheme",
        method: "POST",
        name: "添加/更新过期方案,更新需传入schemeId 添加不传schemeId"
    },
    delExprScheme: {
        url: "/external-api/ticket_verify/expr_scheme/del/{schemeId}",
        method: "GET",
        name: "通过方案id删除方案"
    },
    getExprScheme: {
        url: "/external-api/ticket_verify/expr_scheme/{shopId}",
        method: "GET",
        name: "通过门店id获取方案"
    },
    getExprTickets: {
        url: "/external-api/ticket_verify/expr_tickets/{shopId}",
        method: "GET",
        name: "获取所有过期票券"
    },

    addNewTicketScheme: {
        url: "/external-api/scheme/save",
        method: "POST",
        name: "存储方案"
    },
    delTicketScheme: {
        url: "/external-api/scheme/delete/{schemeId}",
        method: "DELETE",
        name: "通过方案id删除方案"
    },
    getTicketScheme: {
        url: "/external-api/scheme/queryAll/{shopId}",
        method: "GET",
        name: "通过门店id查询所有方案"
    },
    getTicketSchemeDetail: {
        url: "/external-api/scheme/info/{schemeId}",
        method: "GET",
        name: "查询方案的详情信息"
    },
    editTicketScheme: {
        url: "/external-api/scheme/edit",
        method: "PUT",
        name: "编辑方案"
    },
    ticketRank: {
        url: "/manage-system/statistics/recommend/ticket/rank",
        method: "GET",
        name: "票券业绩销量统计"
    },
    statisticsShop: {
        url: "/manage-system/statistics/shop",
        method: "GET",
        name: "门店业绩统计"
    },
    recommendRank: {
        url: "/manage-system/statistics/recommend/rank",
        method: "GET",
        name: "业绩排名统计"
    },
    recommendDetail: {
        url: "/manage-system/statistics/recommend/detail",
        method: "GET",
        name: "业绩明细"
    },
    staffExport: {
        url: "/manage-system/statistics/export",
        method: "GET",
        name: "员工业绩导出"
    },
    verifyNumDay: {
        url: "/manage-system/statis/verifyNumDay",
        method: "POST",
        name: "每天门店核销次数统计"
    },
    ticketVerifyCountDay: {
        url: "/manage-system/statis/ticketVerifyCountDay",
        method: "POST",
        name: "门店 票券核销张数"
    },
    ticketSellNumDay: {
        url: "/manage-system/statis/ticketSellNumDay",
        method: "POST",
        name: "门店 销售门票张数"
    },
    ticketVerifyCountExport: {
        url: "/manage-system/statis/ticketVerifyCountExport",
        method: "POST",
        name: "门店 票券核销次数 导出"
    },
    attendanceExport: {
        url: "/manage-system/attendance/record/export",
        method: "GET",
        name: "导出出勤记录Excel"
    },
    attendanceImport: {
        url: "/manage-system/attendance/record/import",
        method: "POST",
        name: "导入出勤记录Excel"
    },
    attendanceExport2: {
        url: "/manage-system/attendance/record/export2",
        method: "GET",
        name: "导出出勤记录Excel2"
    },
}